// This file is auto-generated by scripts/write-app-version.js
export const APP_VERSION = "2.4.1";
export default APP_VERSION;
